// YoneticiSection.js
import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import './YoneticiSection.css';

const baseUrl = 'https://apiportal.mbsays.com/public/api';
const token = sessionStorage.getItem('authToken') || 'admin_token';
const headers = {
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${token}`
};

const YoneticiSection = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
const [userContact, setUserContact] = useState(null);
  // Modal ve form state’leri
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [modalEditMode, setModalEditMode] = useState(false);
  const [isCreatingUser, setIsCreatingUser] = useState(false);


  // Kullanıcıları çekmek
  const fetchUsers = async () => {
    try {
      const response = await fetch(`${baseUrl}/users`, { headers });
      if (!response.ok) {
        console.error(`Kullanıcılar çekilemedi. Status: ${response.status}`);
        // Hata mesajı veya boş array atayarak map hatasını önleyebilirsiniz:
        setUsers([]);
        return;
      }
      const data = await response.json();
      if (Array.isArray(data)) {
        setUsers(data);
      } else {
        console.error("Beklenmeyen veri formatı:", data);
        setUsers([]);
      }
    } catch (error) {
      console.error("Kullanıcılar çekilirken hata oluştu:", error);
    }
  };

    // Seçilen kullanıcıya ait acil durum bilgisini çek
  const fetchUserContact = async (userId) => {
   try {
     const res = await fetch(`${baseUrl}/emergency-contacts`, { headers });
     if (!res.ok) throw new Error(`Status ${res.status}`);
     const allContacts = await res.json();
     // user_id alanına göre filtrele
     const contact = Array.isArray(allContacts)
       ? allContacts.find(c => c.user_id === userId)
       : null;
     setUserContact(contact || null);
   } catch (err) {
     console.error("Acil durum bilgisi çekilirken hata oluştu:", err);
     setUserContact(null);
   }
 };

  // Verileri yükleyen fonksiyon
  const loadData = async () => {
    await fetchUsers();
    setTimeout(() => setLoading(false), 1000);
  };

  useEffect(() => {
    loadData();
  }, []);

  // Modal işlemleri
 const openModal = (user) => {
  setCurrentUser({
    ...user,
    role: user.roles?.[0]?.name || ""  // Eğer backend roles array içinde dönerse
  });
  setModalEditMode(false);
  setIsCreatingUser(false);
  fetchUserContact(user.id);
  setModalIsOpen(true);
};

  const openCreateUserModal = () => {
    setIsCreatingUser(true);
    setCurrentUser({
      name: "",
      surname: "",
      email: "",
      password: "",
      phone: "",
      address: "",
      birth_date: "",
      tc_no: "",
      start_date: "",
      position: "",
      linkedin: "",
      role: ""
    });
    setUserContact(null);
    setModalEditMode(true);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setCurrentUser(null);
    setModalEditMode(false);
    setIsCreatingUser(false);
    setModalIsOpen(false);
  };

  const handleUserChange = (e) => {
    const { name, value } = e.target;
    setCurrentUser(prev => ({ ...prev, [name]: value }));
  };
const [availableRoles, setAvailableRoles] = useState([]);

const fetchRoles = async () => {
  try {
    const response = await fetch(`${baseUrl}/roles`, { headers });
    const data = await response.json();
    setAvailableRoles(data); // [{ id: 1, name: 'admin' }, ...]
  } catch (error) {
    console.error("Roller çekilirken hata oluştu:", error);
  }
};
  const handleUserSubmit = async (e) => {
  e.preventDefault();

  if (!currentUser.tc_no || !/^[0-9]{11}$/.test(currentUser.tc_no)) {
    alert("TC No 11 haneli olmalıdır.");
    return;
  }

  const payload = {
    name: currentUser.name,
    surname: currentUser.surname,
    phone: currentUser.phone,
    email: currentUser.email,
    address: currentUser.address,
    password: currentUser.password,
    birth_date: currentUser.birth_date,
    tc_no: currentUser.tc_no,
    start_date: currentUser.start_date,
    position: currentUser.position,
    linkedin: currentUser.linkedin
    // 🔸 Role gönderilmeyecek, ayrı olarak handle edilecek
  };

  try {
    if (isCreatingUser) {
      const response = await fetch(`${baseUrl}/users`, {
        method: 'POST',
        headers,
        body: JSON.stringify({ ...payload, role: currentUser.role }) // yeni kullanıcıda role dahil
      });
    } else {
      await fetch(`${baseUrl}/users/${currentUser.id}`, {
        method: 'PUT',
        headers,
        body: JSON.stringify(payload)
      });

      // 🔸 Kullanıcı güncellendikten sonra role ayrı atanmalı
      if (currentUser.role) {
        await fetch(`${baseUrl}/users/${currentUser.id}/assign-role`, {
          method: 'POST',
          headers,
          body: JSON.stringify({ role: currentUser.role })
        });
      }
    }

    await fetchUsers();
    closeModal();
  } catch (error) {
    console.error("Kullanıcı kaydı yapılırken hata oluştu:", error);
  }
};


  const handleDeleteUser = async (id) => {
    if (window.confirm("Silmek istediğinize emin misiniz?")) {
      try {
        await fetch(`${baseUrl}/users/${id}`, {
          method: 'DELETE',
          headers
        });
        await fetchUsers();
        closeModal();
      } catch (error) {
        console.error("Kullanıcı silinirken hata oluştu:", error);
      }
    }
  };


useEffect(() => {
  loadData();
  fetchRoles(); // ⬅ Roller ayrıca çekilir
}, []);
  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Yükleniyor...</p>
      </div>
    );
  }

  return (
    <div className="yonetici-section">
      <h2>Yönetici Paneli</h2>
      <section className="user-management">
        <h3>Kullanıcı Yönetimi</h3>
        <button className="create-user-button" onClick={openCreateUserModal}>
          Yeni Kullanıcı Ekle
        </button>
        <div className="user-cards">
          {users.map(user => {
            // rol gösterimi: admin ise FULL ADMİN, diğer her şey USER
            const roleLabel = user.roles && user.roles.length > 0
  ? user.roles[0].name // sadece ilk rolü gösteriyoruz
  : "Kullanıcı";


            return (
              <div key={user.id} className="user-card">
                <div className="card-row">
                  <div><strong>İsim:</strong> {user.name} {user.surname}</div>
                  <div><strong>E-Posta:</strong> {user.email}</div>
                  <div><strong>Telefon:</strong> {user.phone}</div>
                </div>
                <div className="card-row">
  <div><strong>İşe Başlama Tarihi:</strong> {user.start_date}</div>
  <div><strong>Pozisyon:</strong> {user.position}</div>
  <div><strong>Rol:</strong> {roleLabel}</div>
</div>

                <div className="card-actions">
                  <button className="detail-button" onClick={() => openModal(user)}>
                    Detay
                  </button>
                </div>
              </div>
            );
          })}
        </div>

      </section>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Kullanıcı Detayları"
        className="modal"
        overlayClassName="modal-overlay"
      >
        {currentUser && !modalEditMode ? (
          <div className="user-details">
            <h2>{currentUser.name} {currentUser.surname} Detayları</h2>
            <p><strong>E-Posta:</strong> {currentUser.email}</p>
            <p><strong>Telefon:</strong> {currentUser.phone}</p>
            <p><strong>Adres:</strong> {currentUser.address}</p>
            <p><strong>Doğum Tarihi:</strong> {currentUser.birth_date}</p>
            <p><strong>TC No:</strong> {currentUser.tc_no}</p>
            <p><strong>İşe Başlama Tarihi:</strong> {currentUser.start_date}</p>
            <p><strong>Pozisyon:</strong> {currentUser.position}</p>
            <p>
              <strong>Linkedin:</strong>{" "}
              <a href={currentUser.linkedin} target="_blank" rel="noopener noreferrer">
                Profil
              </a>
            </p>
             {userContact ? (
             <>
               <hr/>
               <h3>Acil Durum Kişisi</h3>
               <p><strong>Ad-Soyad:</strong> {userContact.name}</p>
               <p><strong>Telefon:</strong> {userContact.phone}</p>
               <p><strong>Yakınlık:</strong> {userContact.relationship}</p>
             </>
           ) : (
             <p><em>Acil durum bilgisi bulunamadı.</em></p>
           )}
            <div className="modal-buttons">
              <button className="edit-button" onClick={() => setModalEditMode(true)}>
                Düzenle
              </button>
              <button className="delete-button" onClick={() => handleDeleteUser(currentUser.id)}>
                Sil
              </button>
              <button className="modal-close" onClick={closeModal}>
                x
              </button>
            </div>
          </div>
        ) : currentUser && modalEditMode ? (
          <div className="update-form-container">
            <h2>{isCreatingUser ? "Yeni Kullanıcı Ekle" : `${currentUser.name} ${currentUser.surname} Bilgilerini Güncelle`}</h2>
            <form onSubmit={handleUserSubmit} className="update-form">
              <div className="form-group">
                <label>İsim:</label>
                <input type="text" name="name" value={currentUser.name} onChange={handleUserChange} required />
              </div>
              <div className="form-group">
                <label>Soyad:</label>
                <input type="text" name="surname" value={currentUser.surname} onChange={handleUserChange} required />
              </div>
              <div className="form-group">
                <label>E-Posta:</label>
                <input type="email" name="email" value={currentUser.email} onChange={handleUserChange} required />
              </div>
              <div className="form-group">
                <label>Şifre:</label>
                <input type="password" name="password" value={currentUser.password} onChange={handleUserChange} required={isCreatingUser} />
              </div>
              <div className="form-group">
                <label>Telefon:</label>
                <input type="text" name="phone" value={currentUser.phone} onChange={handleUserChange} />
              </div>
              <div className="form-group">
                <label>Adres:</label>
                <input type="text" name="address" value={currentUser.address} onChange={handleUserChange} />
              </div>
              <div className="form-group">
                <label>Doğum Tarihi:</label>
                <input type="date" name="birth_date" value={currentUser.birth_date} onChange={handleUserChange} required />
              </div>
              <div className="form-group">
                <label>TC No:</label>
                <input
                  type="text"
                  name="tc_no"
                  value={currentUser.tc_no}
                  onChange={handleUserChange}
                  required
                  pattern="[0-9]{11}"
                  title="TC No 11 haneli olmalıdır."
                />
              </div>
              <div className="form-group">
                <label>İşe Başlama Tarihi:</label>
                <input type="date" name="start_date" value={currentUser.start_date} onChange={handleUserChange} required />
              </div>
              <div className="form-group">
                <label>Pozisyon:</label>
                <input type="text" name="position" value={currentUser.position} onChange={handleUserChange} />
              </div>
              <div className="form-group">
                <label>Linkedin:</label>
                <input
                  type="url"
                  name="linkedin"
                  value={currentUser.linkedin}
                  onChange={handleUserChange}
                  required
                  placeholder="https://www.linkedin.com/in/kullaniciadi"
                  title="Geçerli bir URL giriniz, örn: https://www.linkedin.com/in/kullaniciadi"
                />
              </div>
              {!isCreatingUser && (
                <div className="form-group">
  <label>Rol:</label>
  <select
    name="role"
    value={currentUser.role}
    onChange={handleUserChange}
    required
  >
    <option value="">Rol Seçin</option>
    {availableRoles.map((role) => (
      <option key={role.id} value={role.name}>
        {role.name}
      </option>
    ))}
  </select>
</div>

              )}
              <div className="modal-buttons">
                <button type="submit" className="submit-button">
                  {isCreatingUser ? "Oluştur" : "Güncelle"}
                </button>
                <button className="modal-close" onClick={closeModal}>
                  x
                </button>
              </div>
            </form>
          </div>
        ) : null}
      </Modal>
    </div>
  );
};

export default YoneticiSection;
